/// <reference path="typings/swiper.d.ts" />
/// <reference path="typings/jquery.d.ts" />
/// <reference path="commons/xhr.ts" />
/// <reference path="commons/loadJS.ts" />
/// <reference path="commons/cookie.ts" />
var Story = /** @class */ (function () {
    function Story() {
        var _this = this;
        this.quarkPlayerIds = [];
        this.swiperVideos = null;
        this.elements = {
            popup: document.querySelector('.popup-story'),
            container: document.querySelector('.story-slider-container[class*="slider"]'),
            avatars: document.querySelectorAll('.popup-story-avatar .swiper-slide'),
        };
        if (this.elements.popup && this.elements.container) {
            this.elements.storyCards = this.elements.container.querySelectorAll('.story-slider-container .swiper-slide');
            this.init();
        }
        this.storyPlayer = new StoryPlayer(function () {
            _this.swiperVideos.slideNext();
        });
    }
    Story.prototype.init = function () {
        this.initThumbnailsSwiper();
        this.popupOpenClickHandler();
        this.storyCardClickHandler();
        this.progressBarAdjustments();
        this.avatarsClickHandler();
    };
    Story.prototype.initThumbnailsSwiper = function () {
        new Swiper(this.elements.container, {
            preloadImages: false,
            lazyLoading: {
                loadPrevNext: true,
                loadPrevNextAmount: 1
            },
            slidesPerView: 4,
            slidesPerColumn: 1,
            spaceBetween: 16,
            pagination: '.swiper-pagination',
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            slidesPerGroup: 4,
            freeMode: true,
            paginationClickable: true,
            simulateTouch: true,
            slidesPerColumnFill: 'row',
            breakpoints: {
                992: {
                    slidesPerView: 3.5,
                    simulateTouch: false,
                    slidesPerColumn: 1,
                    spaceBetween: 20,
                },
                758: {
                    slidesPerView: 4.5,
                    simulateTouch: true,
                    freeMode: true,
                    slidesPerColumn: 1,
                    spaceBetween: 15,
                }
            }
        });
    };
    Story.prototype.initSwipers = function (initialSlide) {
        var _this = this;
        var popup = this.elements.popup;
        if (!this.swiperVideos) {
            var swiperVideos = popup.querySelector('.popup-story-videos');
            this.swiperVideos = new Swiper(swiperVideos, {
                preloadImages: false,
                lazyLoading: {
                    lazyLoadingInPrevNext: true,
                    lazyLoadingInPrevNextAmount: 2
                },
                watchSlidesVisibility: true,
                slidesPerView: 'auto',
                simulateTouch: false,
                centeredSlides: true,
                loop: false,
                slidesPerGroup: 1,
                slideToClickedSlide: true,
                cube: {
                    slideShadows: true
                },
                paginationClickable: true,
                spaceBetween: 70,
                initialSlide: initialSlide,
                onInit: function () {
                    var spaceLeftEl = _this.elements.popup.querySelector(".space.first");
                    var spaceRightEl = _this.elements.popup.querySelector(".space.last");
                    var hit = (window.innerWidth - document.querySelector('.popup-story-videos .swiper-slide').offsetWidth) / 2;
                    var avatarItemWidth = _this.elements.avatars[0].offsetWidth;
                    if (window.innerWidth > 768) {
                        spaceLeftEl.style.maxWidth = Math.ceil(hit) + "px";
                        spaceRightEl.style.maxWidth = Math.ceil((window.innerWidth - hit) - avatarItemWidth) + "px";
                    }
                },
                breakpoints: {
                    991: {
                        spaceBetween: 15,
                        direction: 'vertical',
                        centeredSlides: false,
                        simulateTouch: true,
                        watchSlidesVisibility: false,
                    }
                },
            });
            this.avatarSetActiveAndScroll(this.swiperVideos.slides[initialSlide].getAttribute('data-target-avatar'));
            var prev = swiperVideos.querySelector('.shadow-navigation-prev'), next = swiperVideos.querySelector('.shadow-navigation-next');
            prev.addEventListener('click', function () {
                _this.swiperVideos.slidePrev();
            });
            next.addEventListener('click', function () {
                _this.swiperVideos.slideNext();
            });
            this.swiperVideos.on('slideChangeStart', function () {
                _this.storyPlayer.play(_this.swiperVideos.slides[_this.swiperVideos.activeIndex]);
                _this.avatarSetActiveAndScroll(_this.swiperVideos.slides[_this.swiperVideos.activeIndex].getAttribute('data-target-avatar'));
            });
        }
        else {
            this.swiperVideos.update();
            this.swiperVideos.attachEvents();
            this.swiperVideos.slideTo(initialSlide);
        }
    };
    Story.prototype.progressBarAdjustments = function () {
        var watchedStories = this.getFromLocalStorage('Tv2WatchedVideo-IDs');
        if (!watchedStories)
            return false;
        var allStoryCards = this.elements.storyCards.concat(this.elements.avatars);
        allStoryCards.forEach(function (el) {
            var progressEl = el.querySelector('.story-caption-wrapper');
            var videoId = el.getAttribute('data-video-id');
            var videoIdSet = el.getAttribute('data-video-id-set');
            if (videoId) {
                if (watchedStories.indexOf(videoId) > -1) {
                    progressEl.setAttribute('data-progress', '0');
                }
            }
            if (videoIdSet) {
                var idSetArr_1 = videoIdSet.split(',');
                var matches = watchedStories.filter(function (item) { return idSetArr_1.includes(item); });
                if (matches) {
                    progressEl.setAttribute('data-progress', parseInt((180 * ((idSetArr_1.length - matches.length) / idSetArr_1.length)).toString()));
                }
            }
        });
    };
    Story.prototype.avatarSetActiveAndScroll = function (slideToIndex) {
        var avatarsArray = Array.prototype.slice.call(this.elements.avatars);
        var targetAvatar = avatarsArray.filter(function (el) { return parseInt(el.getAttribute('data-target-slide')) === parseInt(slideToIndex); })[0];
        this.elements.avatars.forEach(function (avatar) {
            avatar.classList.remove('active');
        });
        if (targetAvatar) {
            targetAvatar.classList.add('active');
            targetAvatar.parentNode.scrollLeft = targetAvatar.offsetLeft - ((window.innerWidth - document.querySelector('.popup-story-videos .swiper-slide').offsetWidth) / 2);
        }
    };
    Story.prototype.avatarsClickHandler = function () {
        var _this = this;
        this.elements.avatars.forEach(function (avatar) {
            avatar.addEventListener('click', function () {
                var targetSlide = avatar.getAttribute('data-target-slide');
                if (_this.swiperVideos && targetSlide) {
                    for (var key in _this.swiperVideos.slides) {
                        if (!_this.swiperVideos.slides.hasOwnProperty(key))
                            continue;
                        if (_this.swiperVideos.slides[key].getAttribute('data-target-avatar') === targetSlide) {
                            _this.swiperVideos.slideTo(parseInt(_this.swiperVideos.slides[key].getAttribute('data-slide-index')) - 1);
                            break;
                        }
                    }
                }
            });
        });
    };
    Story.prototype.popupOpenClickHandler = function () {
        var popupCloseBtn = this.elements.popup.querySelector('.popup-story-close-btn');
        var popupStoryBgBlack = this.elements.popup.querySelector('.popup-story-bg-black');
        popupCloseBtn.addEventListener('click', this.closePopup.bind(this));
        popupStoryBgBlack.addEventListener('click', this.closePopup.bind(this));
    };
    Story.prototype.storyCardClickHandler = function () {
        var _this = this;
        this.elements.storyCards.forEach(function (storyCard) {
            storyCard.addEventListener('click', function (e) {
                e.preventDefault();
                var avatarIndex = storyCard.getAttribute('data-story-avatar');
                var subIndex = storyCard.getAttribute('data-story-subindex') !== '' ? storyCard.getAttribute('data-story-subindex') : 1;
                var initialSlide = parseInt(_this.elements.popup.querySelector('[data-target-avatar="' + avatarIndex + '"][data-avatar-subindex="' + subIndex + '"]').getAttribute('data-slide-index')) - 1;
                _this.elements.popup.style.display = 'block';
                document.querySelector('html').classList.add('story-popup-active');
                _this.initSwipers(initialSlide);
                _this.storyPlayer.play(_this.swiperVideos.slides[initialSlide]);
            });
        });
    };
    Story.prototype.closePopup = function () {
        this.elements.popup.style.display = "none";
        document.querySelector("html").classList.remove("story-popup-active");
        if (this.swiperVideos)
            this.swiperVideos.detachEvents();
    };
    Story.prototype.getFromLocalStorage = function (key) {
        return JSON.parse(localStorage.getItem(key));
    };
    return Story;
}());
var StoryPlayer = /** @class */ (function () {
    function StoryPlayer(endedCallback) {
        this.mediaRequestUrl = "/action/media/";
        this.videos = {};
        this.endedCallback = endedCallback;
    }
    StoryPlayer.prototype.play = function ($slide) {
        var $el = $slide.querySelector('.story-player');
        if ($el) {
            var videoId_1 = $el.getAttribute('id');
            if (typeof this.videos[videoId_1] === 'undefined') {
                // video daha önce init edilmedi, init edelim
                var options = {
                    id: videoId_1,
                    elementId: videoId_1,
                    category: '',
                    url: '',
                    tag: '',
                    pubname: '',
                    maincat: '',
                };
                this.createMediaServiceQuery(options, function (result) {
                    var _this = this;
                    if (result.status) {
                        var quarkPlayer_1 = this.createQuarkInstance(result.options);
                        quarkPlayer_1.adsActive = false;
                        quarkPlayer_1.adsInitialized = false;
                        quarkPlayer_1.endedListenerCalled = false;
                        this.videos[videoId_1] = quarkPlayer_1;
                        // slide container
                        var $slideContainer_1 = $($el).closest('.swiper-slide');
                        // popup container
                        var $popupContainer_1 = $($el).closest('.popup-story');
                        // pause control
                        quarkPlayer_1.player.on("timeupdate", function () {
                            // popup kapandı mı kontrolü
                            if ($popupContainer_1.is(':visible') === false) {
                                quarkPlayer_1.player.pause();
                            }
                            // slide aktif mi kontrolü
                            if ($slideContainer_1 &&
                                $slideContainer_1.hasClass('swiper-slide-active') === false) {
                                quarkPlayer_1.player.pause();
                            }
                        });
                        quarkPlayer_1.player.on("adsready", function () {
                            try {
                                quarkPlayer_1.adsInitialized = true;
                                var adsManager_1 = this.ima.getAdsManager();
                                adsManager_1.addEventListener(window.google.ima.AdEvent.Type.AD_PROGRESS, function (event) {
                                    // popup kapandı mı kontrolü
                                    if ($popupContainer_1.is(':visible') === false) {
                                        adsManager_1.pause();
                                    }
                                    // slide aktif mi kontrolü
                                    if ($slideContainer_1 &&
                                        $slideContainer_1.hasClass('swiper-slide-active') === false) {
                                        adsManager_1.pause();
                                    }
                                });
                                adsManager_1.addEventListener(window.google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, function () {
                                    quarkPlayer_1.adsActive = false;
                                });
                                adsManager_1.addEventListener(window.google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED, function () {
                                    quarkPlayer_1.adsActive = true;
                                });
                            }
                            catch (ex) { }
                        });
                        var endedListener_1 = function () {
                            quarkPlayer_1.endedListenerCalled = true;
                            if (!quarkPlayer_1.adsInitialized) {
                                _this.endedCallback();
                                // console.log("!quarkPlayer.adsInitialized");
                            }
                            else {
                                var adsBeginCount_1 = 0;
                                var adsBeginMax_1 = 10;
                                var adsBeginInterval_1 = setInterval(function () {
                                    adsBeginCount_1++;
                                    if (adsBeginCount_1 >= adsBeginMax_1) {
                                        clearInterval(adsBeginInterval_1);
                                        _this.endedCallback();
                                        // console.log("adsBeginCount >= adsBeginMax");
                                    }
                                    else if (quarkPlayer_1.adsActive) {
                                        clearInterval(adsBeginInterval_1);
                                        var adsCompletedCount_1 = 0;
                                        var adsCompletedMax_1 = 300;
                                        var adsCompletedInterval_1 = setInterval(function () {
                                            adsCompletedCount_1++;
                                            if (adsCompletedCount_1 >= adsCompletedMax_1) {
                                                clearInterval(adsCompletedInterval_1);
                                                _this.endedCallback();
                                                // console.log("adsCompletedCount >= adsCompletedMax");
                                            }
                                            else {
                                                if (!quarkPlayer_1.adsActive) {
                                                    clearInterval(adsCompletedInterval_1);
                                                    _this.endedCallback();
                                                    // console.log("!quarkPlayer.adsActive");
                                                }
                                            }
                                        }, 200);
                                    }
                                }, 500);
                            }
                        };
                        quarkPlayer_1.player.on('ended', function () {
                            if (!quarkPlayer_1.endedListenerCalled) {
                                endedListener_1();
                            }
                        });
                        quarkPlayer_1.player.on('play', function () {
                            quarkPlayer_1.endedListenerCalled = false;
                        });
                    }
                    else {
                        console.log("Story player media service query error", result.message);
                    }
                }.bind(this));
            }
            else {
                if (this.videos[videoId_1].adsActive) {
                    try {
                        var adsManager = this.videos[videoId_1].player.ima.getAdsManager();
                        adsManager.resume();
                    }
                    catch (ex) { }
                }
                else {
                    this.videos[videoId_1].player.play();
                }
            }
        }
        else {
            console.log("Story player video element not founds");
        }
    };
    StoryPlayer.prototype.createMediaServiceQuery = function (options, callback) {
        var xhr = new Xhr();
        var requestUrl = this.mediaRequestUrl + options.id;
        xhr.getJSON(requestUrl, function (data) {
            if (data.Status === 'Success') {
                if (typeof data && data.Media && data.Media.Image !== 'undefined') {
                    options.poster = data.Media.Image + '.jpg';
                }
                else {
                    options.poster = '';
                }
                if (data.Media.Link.ServiceUrl) {
                    options.source = {
                        src: data.Media.Link.ServiceUrl + '/' + data.Media.Link.SecurePath,
                        type: 'application/x-mpegURL'
                    };
                }
                else {
                    options.source = {
                        src: (data.Media.Link.SecurePath.indexOf('http') > -1 ? '' : 'https://tv2.duhnet.tv') + (data.Media.Link.SecurePath.indexOf('/') === 0 || data.Media.Link.SecurePath.indexOf('http') > -1 ? data.Media.Link.SecurePath : '/' + data.Media.Link.SecurePath),
                        type: data.Media.Link.SecurePath.indexOf('.mp4') > -1 ? 'video/mp4' : 'application/x-mpegURL'
                    };
                }
                options.UserName = data.User.Name;
                options.SessionId = data.User.SessionId;
                callback({ status: true, options: options });
            }
            else {
                callback({ status: false, message: 'Something wrong' });
            }
        }, function () {
            callback({ status: false, message: 'Something wrong' });
        });
    };
    StoryPlayer.prototype.createQuarkInstance = function (elementOptions) {
        var options = {
            id: elementOptions.elementId,
            materialId: elementOptions.id,
            debug: false,
            techOrder: ['html5'],
            autoPlay: true,
            viewability: false,
            showAds: true,
            embedUrl: location.protocol + '//' + location.host + '/embed' + elementOptions.url,
            url: location.protocol + '//' + location.host + elementOptions.url,
            contentId: elementOptions.id,
            category: elementOptions.category,
            tag: elementOptions.tag,
            pubname: elementOptions.pubname,
            maincat: elementOptions.maincat,
            playtype: '',
            isSpotVideo: '',
            showNotification: false,
            showBandwidthSelector: true,
            customMenu: true,
            live: false,
            poster: '',
            sources: [elementOptions.source],
            subTitles: null,
            playsinline: true,
            // Birden çok targetı bir arada kullanabilmek için VMAP kullanılmalıdır. VMAP açıklamasına dökümandan ulaşılabilir
            adTagUrl:'https://www.tv2.com.tr/action/vmap?id=' + elementOptions.id + "&plcmt=1",
            plugins: [],
            stats: {
                gemius: {
                    identifier: "dw.q8cb623JEXnnyE2dkL6PeHUvu8Ucmwu8LvtsUIzD.47"
                },
                comscore: {
                    c1: "1",
                    c2: "9053247",
                    c3: "TV2"
                }
            }
        };
        return new QuarkPlayer(options);
    };
    return StoryPlayer;
}());
new Story();
//# sourceMappingURL=stories.js.map